module.exports = __webpack_public_path__ + "static/media/question.9f4f26b2.svg";